<div class="font-poppins">
  <nz-card *ngIf="!knowledgeBaseFormVisible">
    <div class="row m-b-30 d">
      <div class="col-lg-7">
        <div class="d-md-flex">
          <div *ngIf="iconVisible" class="m-b-10 m-r-20">
            <button
              title="Go Back"
              (click)="closeDetail()"
              nz-button
              nzType="default"
            >
              <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            </button>
          </div>
          <div class="m-b-10 m-r-20">
            <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                (keyup)="onKeyUp(searchBox.value)"
                [(ngModel)]="searchTerm"
                #searchBox
              />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <a nz-icon class="opacity-05" (click)="resetSearch()">
                <i nz-icon nzType="close" class="opacity-05"></i>
              </a>
            </ng-template>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
          <div class="m-b-10 m-r-10">
            <button
            nz-button
            nz-popover
            [nzPopoverContent]="popoverContent"
            nzPopoverTrigger="click"
            nzPopoverPlacement="bottom"
            [(nzPopoverVisible)]="filterVisible"
            (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
            class="btn-outline resource-btn"
            style="text-align: center"
          >
         
              <span *ngIf="!this.isArchived">All Knowledge bases</span>
             <span *ngIf="this.isArchived">Archived</span>
              <i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="text-align: left; padding: 0px !important"
              #popoverContent
            >
              <div class="">
                <div nz-row nzGutter="24" style="padding-top: 10px;">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px"
                  >
                    <span class="filter-heading">Show Knowledge bases that are</span>
                  </div>
                </div>
              </div>
              <div style="height: 40px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                <!-- <label nz-checkbox [(ngModel)]="isUsedInLast30Days"
                    >Used in last 30 days</label
                  >
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider> -->
                  <label nz-checkbox [(ngModel)]="archived">Archived</label>
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span (click)="clickFilter()" class="cancel-label"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="applyFilters()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="d-md-flex justify-content-end">
          <!-- <div class="m-b-10 m-r-10">
            <nz-radio-group class="m-r-10">
              <label
                nz-radio-button
                nzValue="mailView"
                nzTooltipTitle="Mail View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
              </label>
              <label
                nz-radio-button
                nzValue="excelView"
                nzTooltipTitle="Excel View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="file-excel"
                  theme="fill"
                ></i>
              </label>
              <label
                nz-radio-button
                nzValue="printView"
                nzTooltipTitle="Print View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="printer"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <!-- <div class="m-b-10 m-r-20">
            <nz-radio-group>
              <label
                nz-radio-button
                nzValue="cardView"
                nzTooltipTitle="Card View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="appstore"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <button
            nz-button=""
            nztype=" primary"
            class="font-small-caps btn-custom-light"
            title="Delete"
            *ngIf="anyChecked"
            nz-wave="[object Object]"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to delete the selected knowledge bases?"
            (nzOnConfirm)="deleteKnowledgeBase(null, true)"
            nzPopconfirmPlacement="topRight"
            style="margin-right: 10px"
            [nzLoading]="isLoading"
          >
            <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
          </button>
          <button
            nz-button
            nzType="default"
            class="btn-fill"
            (click)="openKnowledgeBaseForm()"
          >
            <span>
              <i
                class="fa fa-plus button-plus-icon"
                aria-hidden="true"
              ></i></span
            >&nbsp;NEW
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div>
        <div>
          <nz-table
            #kbListTable
            [nzData]="knowledgeBaseData"
            [nzPageSize]="20"
            [nzLoading]="showLoad"
          >
            <thead>
              <tr>
                <th
                  nzShowCheckbox
                  [(nzChecked)]="allChecked"
                  (nzCheckedChange)="checkAll($event)"
                  [nzDisabled]="this.isArchived"

                ></th>
                <ng-container *ngFor="let column of listOfColumns">
                  <th
                    *ngIf="column.name !== ''"
                    [hidden]="column.name === 'Actions' && this.isArchived"
                    [nzSortOrder]="column.sortOrder"
                    [nzSortFn]="column.sortFn"
                    [nzSortDirections]="column.sortDirections"
                    [nzFilterMultiple]="column.filterMultiple"
                    [nzWidth]="column.colWidth"
                  >
                    {{ column.name }}
                  </th>
                  <th *ngIf="column.name === ''">{{ column.name }}</th>
                </ng-container>
                <!-- <th
                  *ngFor="let column of listOfColumns"
                  [nzSortOrder]="column.sortOrder"
                  [nzSortFn]="column.sortFn"
                  [nzSortDirections]="column.sortDirections"
                >
                  {{ column.name }}
                </th> -->
              </tr>
            </thead>
            <tbody  [@fadeIn]>
              <tr
                *ngFor="let data of kbListTable.data"
                class="data-row cursor-move"
                [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
                
              >
                <ng-container>
                  <td
                    nzShowCheckbox
                    [(nzChecked)]="data.checked"
                    (nzCheckedChange)="refreshStatus()"
                    [nzDisabled]="this.isArchived"

                  ></td>

                  <td
                  (click)="fillKnowledgeBaseForm(data)"
                  >
                    <div class="d-flex align-items-center">
                      <span class="m-b-0">{{ data.question_text }}</span>
                    </div>
                  </td>
                  <td
                  (click)="fillKnowledgeBaseForm(data)"
                  >
                    <ng-container *ngIf="data.tag && data.tag.length > 0">
                      <ng-container
                        *ngIf="data.tag.length <= 2; else moreTags"
                      >
                        <nz-tag
                          *ngFor="let tag of data.tag.slice(0, 2)"
                          [nzMode]="default"
                          [nzColor]="'#ededed'"
                        >
                          {{ tag.tag_name }}
                        </nz-tag>
                      </ng-container>
                      <ng-template #moreTags>
                        <span *ngFor="let tag of data.tag.slice(0, 2)">
                          <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                            tag.tag_name
                          }}</nz-tag>
                        </span>

                        <span
                          nz-popover
                          [nzPopoverContent]="moreContents"
                          nzPopoverPlacement="bottom"
                          (mouseenter)="updateMoreTagsContent(data.tag)"
                          (mouseleave)="resetMoreTagsContent()"
                        >
                          <nz-tag [nzMode]="default" [nzColor]="'#ededed'"
                            >+{{ data.tag.length - 2 }} more</nz-tag
                          >
                        </span>

                        <ng-template #moreContents>
                          <span  *ngFor="let tag of moreTagsContent">
                            <nz-tag
                              [nzMode]="default"
                              [nzColor]="'#ededed'"
                              >{{ tag }}</nz-tag
                            >
                          </span>
                        </ng-template>
                      </ng-template>
                    </ng-container>
                  </td>
                  <!-- <td>
                    <nz-tag
                      *ngFor="let tag of data.tag; let i = index"
                      [nzMode]="default"
                      [nzColor]="'#ededed'"
                    >
                      {{ tag.tag_name }}
                    </nz-tag>
                  </td> -->

                  <td *ngIf="!this.isArchived">
                    <!-- <span class="data-row-action"> -->
                      <span class="">
                      <!-- <a
                        class="m-r-5"
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nz-tooltip
                        nzTooltipTitle="Edit"
                      >
                        <i
                          nz-icon
                          nzType="edit"
                          theme="outline"
                          (click)="fillKnowledgeBaseForm(data)"
                        ></i>
                      </a> -->
                      <button
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nz-tooltip
                        nzTooltipTitle="Delete"
                        (click)="$event.stopPropagation()"
                      >
                        <i
                          nz-icon
                          nzType="delete"
                          theme="outline"
                          nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this knowledge base?"
                          (nzOnConfirm)="deleteKnowledgeBase(data.knowledge_base_id)"
                        ></i>
                      </button>
                    </span>
                     
                  </td>

                  <!-- <td>
                    <span class="data-row-action">
                      <i
                        nz-icon
                        nzType="edit"
                        nzTheme="outline"
                        (click)="fillKnowledgeBaseForm(data)"
                        class="m-r-15"
                      ></i>
                      <i
                        nz-icon
                        nzType="delete"
                        theme="outline"
                        nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete this knowledge base?"
                        (nzOnConfirm)="
                          deleteKnowledgeBase(data.knowledge_base_id)
                        "
                      ></i>
                    </span>
                  </td> -->
                </ng-container>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </div>
  </nz-card>

  <nz-card
    id="createKnowledgeBase"
    *ngIf="knowledgeBaseFormVisible || knowledgeRadioVisible"

    class="margin-bottom: 0px"
  >
    <div nz-row nzGutter="16"></div>
    <div>
      <div nz-row>
    <nz-spin nzTip="Please wait..." [nzSpinning]="isLoading">    
        <div nz-col nzSpan="12">
          <!-- <div nz-row>
            <div nz-col nzSpan="24">
              <nz-radio-group [(ngModel)]="radioValue" nzSize="small">
                <label nz-radio-button nzValue="0" style="font-weight: 500"
                  >Use AI to create from resources</label
                >
                <label nz-radio-button nzValue="1" style="font-weight: 500"
                  >Auto generate</label
                >
                <label nz-radio-button nzValue="2" style="font-weight: 500"
                  >Create Manually</label
                >
              </nz-radio-group>
            </div>
          </div> -->

          <div class="m-l-5">
            <div *ngIf="radioValue === '0'" class="m-t-30">
              <span
                style="letter-spacing: 1px; color: #545461; font-weight: 600"
                >Select Resources</span
              >
            </div>

            <div *ngIf="radioValue === '0'">
              <div class="p-v-25">
                <div class="row d">
                  <div class="col-lg-11">
                    <div class="d-md-flex">
                      <div class="marginSearch">
                        <nz-input-group [nzPrefix]="prefixTemplate">
                          <input
                            type="text"
                            nz-input
                            placeholder="Search"
                            (keyup)="onKeyUp(searchBox.value)"
                            #searchBox
                          />
                        </nz-input-group>
                        <ng-template #prefixTemplate>
                          <i nz-icon nzType="search" class="opacity-05"></i>
                        </ng-template>
                      </div>
                      <div class="marginSearch">
                        <button
                          nz-button
                          nz-popover
                          [nzPopoverContent]="content"
                          nz-popover
                          nzPopoverTrigger="click"
                          nzPopoverPlacement="bottom"
                          [(nzPopoverVisible)]="filterVisible"
                          class="btn-outline resource-btn"
                          style="text-align: center"
                        >
                          All Resources<i
                            nz-icon
                            nzType="caret-down"
                            style="position: relative; top: -1px; left: -3px"
                            nzTheme="outline"
                          ></i>
                        </button>
                      </div>
                      <div>
                        <button
                          nz-button
                          nzType="default"
                          nz-popover
                          [(nzPopoverVisible)]="visible"
                          nzPopoverPlacement="bottomRight"
                          nzPopoverTrigger="click"
                          [nzPopoverContent]="contentTemplate"
                          class="btn-fill"
                        >
                          <span
                            ><i
                              class="fa fa-plus button-plus-icon"
                              aria-hidden="true"
                            ></i></span
                          >&nbsp;New
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div nz-row>
                  <div nz-col nzSpan="22">
                    <div class="m-t-20">
                      <nz-table
                        #resourcesListTable
                        [nzData]="tableResourceData"
                        [nzPageSize]="50"
                        nzShowSizeChanger
                        class="no-border-last"
                        #sortTable
                      >
                        <thead>
                          <tr>
                            <th
                              nzShowCheckbox
                              ngDefaultControl
                              [ngModelOptions]="{ standalone: true }"
                              class="m-r-15"
                            ></th>

                            <th>Name</th>
                            <th>Size</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of resourcesListTable.data">
                            <ng-container>
                              <td
                                nzShowCheckbox
                                ngDefaultControl
                                [ngModelOptions]="{ standalone: true }"
                                class="m-r-15"
                              ></td>
                              <td>
                                <span class="m-b-0">{{ item.name }}</span>
                              </td>
                              <td>{{ item.size }}</td>
                            </ng-container>
                          </tr>
                        </tbody>
                      </nz-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="m-t-30" *ngIf="radioValue === '1'">
              <div class="m-b-10">
                <span style="font-size: 11px; color: #2d2d35; font-weight: 600"
                  >Please enter the URL to generate Articles</span
                >
              </div>
              <div nz-row>
                <div nz-col nzSpan="17">
                  <nz-form-item style="margin-bottom: 5px">
                    <nz-form-control class="m-b-10">
                      <input
                        nz-input
                        id="email"
                        placeholder="http://noritz.com/products/"
                      />
                    </nz-form-control>
                    <nz-form-control>
                      <input
                        nz-input
                        id="email"
                        placeholder="http://noritz.com/products/"
                      />
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div nz-row>
                <div nz-col nzSpan="5">
                  <u
                    ><a class="add-label">
                      <i nz-icon nzType="plus" theme="outline"></i> Add Row
                    </a></u
                  >
                </div>
              </div>
            </div>

            <div class="m-t-30" *ngIf="radioValue === '2'" > 
              <form
                nz-form
                nzLayout="vertical"
                class=""
                
                [formGroup]="knowledgeBaseForm"
              >
                <div nz-row>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-label nzRequired>Question</nz-form-label>
                      <nz-form-control>
                        <nz-form-control
                          _ngcontent-jfp-c14=""
                          class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
                        >
                          <div class="ant-form-item-control">
                            <span class="ant-form-item-children">
                              <input
                                _ngcontent-jfp-c14=""
                                nz-input=""
                                placeholder="Name"
                                formControlName="question_text"
                                nzSize="medium"
                                class="ant-input ng-untouched ng-pristine ng-invalid" required/><span
                                class="ant-form-item-children-icon"
                              >
                            </span>
                              <span class="text-danger" *ngIf="knowledgeBaseForm.get('question_text')?.errors?.['required'] && knowledgeBaseForm.get('question_text')?.touched">This field is required.</span>
                            </span>
                          </div>
                        </nz-form-control>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
                <div nz-row>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-label nzRequired >Answer</nz-form-label>
                      <nz-form-control>
                        <!-- <div> -->
                          <angular-editor
                            [config]="editorConfig"
                            class="editor-container"
                            (keyup)="onType()"
                            formControlName="answer_text"
                          ></angular-editor>
                        <!-- </div> -->
                      </nz-form-control>
                      <span class="text-danger" *ngIf="knowledgeBaseForm.get('answer_text')?.errors?.['required'] && knowledgeBaseForm.get('answer_text')?.touched">This field is required.</span>
                    </nz-form-item>
                  </div>
                </div>
                <!-- <div nz-row>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-label nzRequired >Save to Folder</nz-form-label>
                      <nz-form-control>
                        <nz-select
                          formControlName="resource_id"
                          nzShowSearch
                          nzAllowClear
                          class="ant-col-30 m-r-10"
                          nzPlaceHolder="Select Folder"
                          nzTitle="Select Folder"
                        >
                          <nz-option
                            nzCustomContent
                            *ngFor="let item of resourceData"
                            [nzLabel]="item.resource_name"
                            [nzValue]="item.resource_id"
                          >
                            {{ item.resource_name }}</nz-option
                          >
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div> -->

                <div nz-row>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-label nzFor="Tag">Tags</nz-form-label>
                      <nz-form-control>
                        <nz-select
                          formControlName="tag"
                          nzMode="tags"
                          nzPlaceHolder="Please select"
                          nzSize="small"
                        >
                          >
                          <nz-option
                            *ngFor="let option of tagFilterList"
                            [nzLabel]="option.text"
                            [nzValue]="option.value"
                          ></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div nz-row *ngIf="radioValue === '0'">
            <div nz-col [nzSpan]="calSpan">
              <div class="d-flex align-items-center justify-content-end">
                <span class="cancel-label">Reset</span>
                <button
                  _ngcontent-jfp-c14=""
                  nz-button=""
                  nztype="default"
                  class="btn-fill m-l-20"
                >
                  <span>Generate</span>
                </button>
              </div>
            </div>
          </div>

          <div nz-row *ngIf="radioValue === '1'">
            <div nz-col [nzSpan]="17">
              <div class="d-flex align-items-center justify-content-end">
                <span class="cancel-label">Reset</span>
                <button
                  _ngcontent-jfp-c14=""
                  nz-button=""
                  nztype="default"
                  class="btn-fill m-l-20"
                >
                  <span>Generate</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          nz-col
          nzSpan="12"
          *ngIf="radioValue === '0' || radioValue === '1'"
        >
          <nz-card
            style="background-color: #ededed; border-radius: 15px; height: 100%"
          >
            <nz-card
              [nzBodyStyle]="{ padding: '0px' }"
              style="border-radius: 15px"
            >
              <nz-collapse nzAccordion [nzBordered]="false">
                <nz-collapse-panel [nzHeader]="specHeader">
                  <ng-template #specHeader>
                    <div nz-row>
                      <div nz-col>
                        <span class="spanning"
                          >What to do if you smell a gas?</span
                        >
                      </div>
                    </div>
                  </ng-template>
                </nz-collapse-panel>
              </nz-collapse>
            </nz-card>
            <nz-card
              [nzBodyStyle]="{ padding: '0px' }"
              style="border-radius: 15px"
            >
              <nz-collapse
                nzAccordion
                [nzBordered]="false"
                [nzActivePanel]="activePanel"
              >
                <nz-collapse-panel [nzHeader]="specHeader1">
                  <ng-template #specHeader1>
                    <div nz-row (click)="setActivePanel($event, panel)">
                      <div nz-col>
                        <span class="spanning"
                          >What to do if you smell a gas?</span
                        >
                      </div>
                    </div>
                  </ng-template>
                  <div
                    style="
                      font-size: 11px;
                      color: #2d2d35;
                      font-weight: 400;
                      font-family: Poppins;
                    "
                    class="m-l-50"
                  >
                    <ul style="margin-bottom: 0px">
                      <li>Do not try to light any appliance.</li>
                      <li>
                        Do not touch any electrical switch; do not use any phone
                        in your building.
                      </li>
                      <li>
                        Immediately call your gas supplier from a neighbor's
                        phone.
                      </li>
                    </ul>
                  </div>
                  <div
                    style="
                      font-size: 11px;
                      color: #2d2d35;
                      font-weight: 400;
                      font-family: Poppins;
                    "
                    class="m-l-50"
                  >
                    <span>Follow the gas supplier's instructions</span>
                  </div>

                  <div
                    style="
                      font-size: 11px;
                      color: #2d2d35;
                      font-weight: 400;
                      font-family: Poppins;
                    "
                    class="m-l-50"
                  >
                    <ul style="margin-bottom: 0px">
                      <li>
                        If you cannot each you gas supplier , call the fire
                        department.
                      </li>
                    </ul>
                  </div>
                  <nz-divider
                    style="margin-top: 10px; margin-bottom: 15px"
                  ></nz-divider>
                  <form nz-form nzLayout="vertical">
                    <div nz-row>
                      <div nz-col nzSpan="18">
                        <nz-form-item style="margin-bottom: 0px">
                          <nz-form-label nzFor="Tag">Tags</nz-form-label>
                          <nz-form-control>
                            <div nz-row>
                              <div nz-col nzSpan="18">
                                <nz-select
                                  
                                  nzAllowClear
                                  class="ant-col-30 m-r-10"
                                  nzMode="multiple"
                                  [ngModelOptions]="{ standalone: true }"
                                  nzPlaceHolder="Tags"
                                  nzTitle="Please select"
                                >
                                  <nz-option
                                    *ngFor="let tag of tagFilterList"
                                    [nzValue]="tag.id"
                                    [nzLabel]="tag.tag_name"
                                    [nzDisabled]="UpdateDisabled"
                                  >
                                  </nz-option>
                                </nz-select>
                              </div>
                            </div>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                    </div>
                  </form>
                </nz-collapse-panel>
              </nz-collapse>
            </nz-card>
          </nz-card>
        </div>

        <div nz-col nzSpan="24">
          <!-- padding-top: 20px;
          padding-bottom: 20px; -->
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <div nz-col nzSpan="12">
              <button
                *ngIf="!updateMode"
                _ngcontent-jfp-c14=""
                (click)="resetKnowledgeBaseForm()"
                nz-button=""
                nztype="default"
                class="ant-btn ant-btn-default"
                nz-wave="[object Object]"
              >
                <!----><span>Reset</span>
              </button>
              <button
                *ngIf="updateMode"
                _ngcontent-jfp-c14=""
                (click)="resetUpdateForm()"
                nz-button=""
                nztype="default"
                class="ant-btn ant-btn-default"
                nz-wave="[object Object]"
              >
                <!----><span>Reset</span>
              </button>
            </div>

            <div nz-col nzSpan="12" style="text-align: right">
              <div *ngIf="radioValue === '0'">
                <span
                  style="
                    font-size: 11px;
                    color: #545461;
                    font-weight: 500;
                    font-family: Poppins;
                  "
                  class="m-r-10"
                  >Create same folder structure as resources </span
                ><nz-switch [ngModel]="true"></nz-switch>
              </div>
              <!-- class="cancel-label m-l-30" -->
              <button
              nz-button=""
              nztype="default"
              class="cancelbtn-outline"
              (click)="this.checkFormState()"
            >
              <span>Cancel</span>
            </button>
              <!-- <span
                class="cancelbtn-outline"
                (click)="this.checkFormState()"
                >Cancel</span
              > -->
              <!-- (click)="closeKnowledgeBaseForm()" -->
              <button
                nz-button=""
                nztype="default"
                *ngIf="!updateMode"
                class="ant-btn ant-btn-primary m-l-10"
                style="padding-left: 25px; padding-right: 25px"
                (click)="submitKnowledgeBase()"
                [nzLoading]="isLoading"
                [disabled]="!this.knowledgeBaseForm.valid"
              >
                <span>Save</span>
              </button>

              <button
                nz-button=""
                nztype="default"
                *ngIf="updateMode"
                class="ant-btn ant-btn-primary m-l-10"
                style="padding-left: 25px; padding-right: 25px"
                [nzLoading]="isLoading"
                (click)="updateKnowledgeBase()"
                [disabled]="!this.knowledgeBaseForm.valid || !knowledgeBaseForm.dirty"
              >
                <span>Update</span>
              </button>
            </div>
          </div>
        </div>
    </nz-spin>
      </div>
    </div>
  </nz-card>
</div>
